export default __webpack_public_path__ + "static/media/D026_tn.a9d797ff.jpg";